import * as z from 'zod';

export const techPreferenceQuerySchema = z.enum(['linux', 'mac', 'windows']);

type TTechPreferenceQuerySchema = z.infer<typeof techPreferenceQuerySchema>;
export type TechPreferenceMutationSchema = TTechPreferenceQuerySchema;

export const techPreferenceFormSchema = z.object({
  name: z.string(),
  value: techPreferenceQuerySchema,
});

export type TechPreferenceFormSchema = z.infer<typeof techPreferenceFormSchema>;

export const defaultTechPreference = null;

export const techPreferenceOptions: TechPreferenceFormSchema[] = [
  { name: 'Linux', value: 'linux' },
  { name: 'Mac', value: 'mac' },
  { name: 'Windows', value: 'windows' },
];

export function strToTechPreference(
  techPreference?: TTechPreferenceQuerySchema | null
): TechPreferenceFormSchema | null {
  return techPreferenceOptions.find((option) => option?.value === techPreference) ?? null;
}

export function techPreferenceToStr(techPreference: TechPreferenceFormSchema | null) {
  return techPreference?.value ?? null;
}
